module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 remove-margins"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('CustomerConfirmedReservations')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "text-center hidden-sm hidden-xs"
  }, [_c('i', {
    staticClass: "fa fa-bookmark-o"
  }), _vm._v(" Bookings\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-center hidden-md hidden-lg"
  }, [_c('i', {
    staticClass: "fa fa-bookmark-o"
  }), _vm._v(" Bookings\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-10 col-sm-offset-1"
  }, [_c('hr', {
    staticClass: "hidden-xs hidden-sm",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "10px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-08476752!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customers/Reservation/MyReservations.vue
// module id = 601
// module chunks = 2